<template>
  <div
    v-if="images.length"
    uk-grid
    class="mini-gallery uk-grid-small uk-margin-medium"
  >
    <div class="uk-width-small" v-for="image in images">
      <thumbnail :attachment="image" />
    </div>
  </div>
</template>

<script>
import Thumbnail from '@/components/Thumbnail';

export default {
  name: 'mini-gallery',
  components: {
    Thumbnail,
  },
  props: {
    record: {
      type: Object,
      required: true,
    },
  },
  computed: {
    images() {
      const { media } = this.record;
      if (!media) return [];
      return media.filter(m => m.type === 'IMAGE');
    },
  },
};
</script>



// WEBPACK FOOTER //
// MiniGallery.vue?6199e2d0